<template>

  <div class="text-center">
        <v-dialog
        :value="clicks"
          width="500"
        >
          <template v-slot:activator="{ clicks }">
            <v-btn
              color="green lighten-2"
              dark
              v-on="clicks"
            >
              Play
            </v-btn>
          </template>

          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title
              style="margin-bottom:30px;"
            >
              Choose Player
            </v-card-title>

            <v-card-text>
<v-btn
      color="primary"
      v-for="(user) in admins"
      v-on:click="selectUser(user)">{{users.firstName}}</v-btn>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn
                color="primary"
                text
                v-on:click="toggleClick()"

              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
</template>

<script>
import DataLoader from "../scripts/DataLoader";
export default{
  name: "UserPicker",
  data(){
    return{
      userList:"",
      dialog:false
    }
  },
  props:{
    clicks: Boolean
  },
  firestore(){
    return{
      users:this.getAdmin()
    }
  },
  computed:{

      showDialog:function(){
        // debugger
        console.log("dialog: "+this.dialog);
        console.log("clicks: "+ this.clicks);
         this.dialog=true
         return this.dialog
      }

  },
  mounted(){
    var loader = new DataLoader();
    console.log("mounted userpicker.")
  },
  methods:{
    toggleClick(){

      console.log("clicked is: "+ this.clicks);
      this.$emit('childEvent',false)
    },
    getAdmin(){
      var loader = new DataLoader();
      var admins = loader.Get("Users","isAdmin");
      admins.get().then(collection =>{
        collection.forEach(doc=>{
          console.log(doc.data().firstName);
        });
        // if(doc.exists){
        //   var tempUser = doc.data();
        //   if(tempUser.isAdmin){
        //     console.log("isAdmin!")
        //   self.$router.replace({name: "AdminDash", params:{uid:id}});
      })
      return admins;
    }

  }

}
</script>
